import { Outlet } from 'react-router-dom';

export default function Onboarding() {
  return (
    <>
      <Outlet />
    </>
  );
}
